import one from '../../Image/1.jpg';
import two from '../../Image/2.jpg';
import three from '../../Image/3.jpg';
import four from '../../Image/4.jpg';
import five from '../../Image/5.jpg';
import six from '../../Image/6.jpg';
import seven from '../../Image/7.jpg';
import eight from '../../Image/8.jpg';
import nine from '../../Image/9.jpg';
import ten from '../../Image/10.jpg';
import eleven from '../../Image/11.jpg';
import twelve from '../../Image/12.jpg';
import thirteen from '../../Image/13.jpg';
import fourteen from '../../Image/14.jpg';
import fifteen from '../../Image/15.jpg';
import sixteen from '../../Image/16.jpg';
import seventeen from '../../Image/17.jpg';
import eighteen from '../../Image/18.jpg';
import nineteen from '../../Image/19.jpg';
import twenty from '../../Image/20.jpg';
import twentyOne from '../../Image/21.jpg';
import twentyTwo from '../../Image/22.jpg';
import twentyThree from '../../Image/23.jpg';
import twentyFour from '../../Image/24.jpg';
import twentyFive from '../../Image/25.jpg';
import twentySix from '../../Image/26.jpg';
import twentySeven from '../../Image/27.jpg';
import twentyEight from '../../Image/28.jpg';
import twentyNine from '../../Image/29.jpg';
import thirty from '../../Image/30.jpg';
import thirtyOne from '../../Image/31.jpg';
import thirtyTwo from '../../Image/32.jpg';
import thirtyThree from '../../Image/33.jpg';
import thirtyFour from '../../Image/34.jpg';
import thirtyFive from '../../Image/35.jpg';
import thirtySix from '../../Image/36.jpg';
import thirtySeven from '../../Image/37.jpg';
import thirtyEight from '../../Image/38.jpg';
import thirtyNine from '../../Image/39.jpg';
import forty from '../../Image/40.jpg';
import fortyOne from '../../Image/41.jpg';
import fortyTwo from '../../Image/42.jpg';
import fortyThree from '../../Image/43.jpg';
import fortyFour from '../../Image/44.jpg';

// products
import p1 from '../ProductManuplation/1.jpg';
import p2 from '../ProductManuplation/2.jpg';
import p3 from '../ProductManuplation/3.jpg';
import p4 from '../ProductManuplation/4.jpg';
import p5 from '../ProductManuplation/5.jpg';
import p6 from '../ProductManuplation/6.jpg';
import p7 from '../ProductManuplation/7.jpg';
import p8 from '../ProductManuplation/8.jpg';
import p9 from '../ProductManuplation/9.jpg';
import p10 from '../ProductManuplation/10.jpg';
import p11 from '../ProductManuplation/11.jpg';
import p12 from '../ProductManuplation/12.jpg';
import p13 from '../ProductManuplation/13.jpg';
import p14 from '../ProductManuplation/14.jpg';
import p15 from '../ProductManuplation/15.jpg';
import p16 from '../ProductManuplation/16.jpg';
import p17 from '../ProductManuplation/17.jpg';
import p18 from '../ProductManuplation/18.jpg';
import p19 from '../ProductManuplation/19.jpg';
import p20 from '../ProductManuplation/20.jpg';
import p21 from '../ProductManuplation/21.jpg';
import p22 from '../ProductManuplation/22.jpg';
import p23 from '../ProductManuplation/23.jpg';
import p24 from '../ProductManuplation/24.jpg';
import p25 from '../ProductManuplation/25.jpg';
import p26 from '../ProductManuplation/26.jpg';
import p27 from '../ProductManuplation/27.jpg';
import p28 from '../ProductManuplation/28.jpg';
import p29 from '../ProductManuplation/29.jpg';
import p30 from '../ProductManuplation/30.jpg';
import p31 from '../ProductManuplation/31.jpg';
import p32 from '../ProductManuplation/32.jpg';
import p33 from '../ProductManuplation/33.jpg';
import p34 from '../ProductManuplation/34.jpg';
import p35 from '../ProductManuplation/35.jpg';
import p36 from '../ProductManuplation/36.jpg';
import p37 from '../ProductManuplation/37.jpg';
import p38 from '../ProductManuplation/38.jpg';
import p39 from '../ProductManuplation/39.jpg';
import p40 from '../ProductManuplation/40.jpg';
import p41 from '../ProductManuplation/41.jpg';
import p42 from '../ProductManuplation/42.jpg';
import p43 from '../ProductManuplation/43.jpg';
import p44 from '../ProductManuplation/44.jpg';
import p45 from '../ProductManuplation/45.jpg';
import p46 from '../ProductManuplation/46.jpg';
import p47 from '../ProductManuplation/47.jpg';
import p48 from '../ProductManuplation/48.jpg';
import p49 from '../ProductManuplation/49.jpg';
import p50 from '../ProductManuplation/50.jpg';
import p51 from '../ProductManuplation/51.jpg';
import p52 from '../ProductManuplation/52.jpg';
import p53 from '../ProductManuplation/53.jpeg';
import p54 from '../ProductManuplation/54.jpeg';
import p55 from '../ProductManuplation/55.png';
import p56 from '../ProductManuplation/56.jpeg';
import p57 from '../ProductManuplation/57.jpeg';
import p58 from '../ProductManuplation/58.png';
import p59 from '../ProductManuplation/59.png';
import p60 from '../ProductManuplation/60.jpg';
import p61 from '../ProductManuplation/61.png';
import p62 from '../ProductManuplation/62.png';
import p63 from '../ProductManuplation/63.png';
import p64 from '../ProductManuplation/64.png';
import p65 from '../ProductManuplation/65.png';
import p66 from '../ProductManuplation/66.png';
import p67 from '../ProductManuplation/67.png';
import p68 from '../ProductManuplation/68.png';
import p69 from '../ProductManuplation/69.jpg';
import p70 from '../ProductManuplation/70.jpg';
import p71 from '../ProductManuplation/71.jpg';
import p72 from '../ProductManuplation/72.jpg';
import p73 from '../ProductManuplation/73.jpg';
import p74 from '../ProductManuplation/74.jpeg';
import p75 from '../ProductManuplation/75.jpeg';
import p76 from '../ProductManuplation/76.jpeg';
import p77 from '../ProductManuplation/77.jpeg';
import p78 from '../ProductManuplation/78.jpeg';
import p79 from '../ProductManuplation/79.jpeg';
import p80 from '../ProductManuplation/80.jpeg';
import p81 from '../ProductManuplation/81.jpeg';
import p82 from '../ProductManuplation/82.jpg';
import p83 from '../ProductManuplation/83.jpg';
import p84 from '../ProductManuplation/84.jpg';
import p85 from '../ProductManuplation/85.jpg';
import p86 from '../ProductManuplation/86.jpg';
import p87 from '../ProductManuplation/87.jpg';
import p88 from '../ProductManuplation/88.jpg';
import p89 from '../ProductManuplation/89.jpg';
import p90 from '../ProductManuplation/90.jpg';
// import p91 from '../ProductManuplation/91.png';
import p92 from '../ProductManuplation/92.jpg';
import p93 from '../ProductManuplation/93.jpg';
import p94 from '../ProductManuplation/94.jpg';
import p95 from '../ProductManuplation/95.jpg';
import p96 from '../ProductManuplation/96.jpg';
import p97 from '../ProductManuplation/97.jpg';
import p98 from '../ProductManuplation/98.jpg';
import p99 from '../ProductManuplation/99.jpg';
import p100 from '../ProductManuplation/100.jpg';
import p101 from '../ProductManuplation/101.jpg';
import p102 from '../ProductManuplation/102.jpg';
import p103 from '../ProductManuplation/103.jpg';
import p104 from '../ProductManuplation/104.jpeg';
import p105 from '../ProductManuplation/105.jpeg';
import p106 from '../ProductManuplation/106.jpeg';
import p107 from '../ProductManuplation/107.jpeg';
import p108 from '../ProductManuplation/108.jpeg';
import p109 from '../ProductManuplation/109.jpeg';
import p110 from '../ProductManuplation/110.jpeg';




export const Data = [
    { title: "Eye", src: one, type:'hotel-resorts' },
    { title: "Colors", src: two, type:'hotel-resorts' },
    { title: "Face", src: three, type:'hotel-resorts' },
    { title: "Hair", src: four, type:'hotel-resorts' },
    { title: "Eye", src: five, type:'hotel-resorts' },
    { title: "Colors", src: six, type:'hotel-resorts' },
    { title: "Face", src: seven, type:'hotel-resorts' },
    { title: "Hair", src: eight, type:'hotel-resorts' },
    { title: "Eye", src: nine, type:'hotel-resorts' },
    { title: "Colors", src: ten, type:'hotel-resorts' },
    { title: "Face", src: eleven, type:'hotel-resorts' },
    { title: "Hair", src: twelve, type:'hotel-resorts' },
    { title: "Eye", src: thirteen, type:'hotel-resorts' },
    { title: "Colors", src: fourteen, type:'hotel-resorts' },
    { title: "Face", src: fifteen, type:'hotel-resorts' },
    { title: "Hair", src: sixteen, type:'hotel-resorts' },
    { title: "Eye", src: seventeen, type:'hotel-resorts' },
    { title: "Colors", src: eighteen, type:'hotel-resorts' },
    { title: "Face", src: nineteen, type:'hotel-resorts' },
    { title: "Hair", src: twenty, type:'hotel-resorts' },
    { title: "Eye", src: twentyOne, type:'hotel-resorts' },
    { title: "Colors", src: twentyTwo, type:'hotel-resorts' },
    { title: "Face", src: twentyThree, type:'hotel-resorts' },
    { title: "Hair", src: twentyFour, type:'hotel-resorts' },
    { title: "Eye", src: twentyFive, type:'hotel-resorts' },
    { title: "Colors", src: twentySix, type:'hotel-resorts' },
    { title: "Face", src: twentySeven, type:'hotel-resorts' },
    { title: "Hair", src: twentyEight, type:'hotel-resorts' },
    { title: "Eye", src: twentyNine, type:'hotel-resorts' },
    { title: "Colors", src: thirty, type:'hotel-resorts' },
    { title: "Face", src: thirtyOne, type:'hotel-resorts' },
    { title: "Hair", src: thirtyTwo, type:'hotel-resorts' },
    { title: "Eye", src: thirtyThree, type:'hotel-resorts' },
    { title: "Colors", src: thirtyFour, type:'hotel-resorts' },
    { title: "Face", src: thirtyFive, type:'hotel-resorts' },
    { title: "Hair", src: thirtySix, type:'hotel-resorts' },
    { title: "Eye", src: thirtySeven, type:'hotel-resorts' },
    { title: "Colors", src: thirtyEight, type:'hotel-resorts' },
    { title: "Face", src: thirtyNine, type:'hotel-resorts' },
    { title: "Hair", src: forty, type:'hotel-resorts' },
    { title: "Eye", src: fortyOne, type:'hotel-resorts' },
    { title: "Colors", src: fortyTwo, type:'hotel-resorts' },
    { title: "Face", src: fortyThree, type:'hotel-resorts' },
    { title: "Hair", src: fortyFour, type:'hotel-resorts' },
];



export const productData = [
    { title: "null", src: p1 },
    { title: "null", src: p2 },
    { title: "null", src: p3 },
    { title: "null", src: p4 },
    { title: "null", src: p5 },
    { title: "null", src: p6 },
    { title: "null", src: p7 },
    { title: "null", src: p8 },
    { title: "null", src: p9 },
    { title: "null", src: p10 },
    { title: "null", src: p11 },
    { title: "null", src: p12 },
    { title: "null", src: p13 },
    { title: "null", src: p14 },
    { title: "null", src: p15 },
    { title: "null", src: p16 },
    { title: "null", src: p17 },
    { title: "null", src: p18 },
    { title: "null", src: p19 },
    { title: "null", src: p20 },
    { title: "null", src: p21 },
    { title: "null", src: p22 },
    { title: "null", src: p23 },
    { title: "null", src: p24 },
    { title: "null", src: p25 },
    { title: "null", src: p26 },
    { title: "null", src: p27 },
    { title: "null", src: p28 },
    { title: "null", src: p29 },
    { title: "null", src: p30 },
    { title: "null", src: p31 },
    { title: "null", src: p32 },
    { title: "null", src: p33 },
    { title: "null", src: p34 },
    { title: "null", src: p35 },
    { title: "null", src: p36 },
    { title: "null", src: p37 },
    { title: "null", src: p38 },
    { title: "null", src: p39 },
    { title: "null", src: p40 },
    { title: "null", src: p41 },
    { title: "null", src: p42 },
    { title: "null", src: p43 },
    { title: "null", src: p44 },
    { title: "null", src: p45 },
    { title: "null", src: p46 },
    { title: "null", src: p47 },
    { title: "null", src: p48 },
    { title: "null", src: p49 },
    { title: "null", src: p50 },
    { title: "null", src: p51 },
    { title: "null", src: p52 },
    { title: "null", src: p53 },
    { title: "null", src: p54 },
    { title: "null", src: p55 },
    { title: "null", src: p56 },
    { title: "null", src: p57 },
    { title: "null", src: p58 },
    { title: "null", src: p59 },
    { title: "null", src: p60 },
    { title: "null", src: p61 },
    { title: "null", src: p62 },
    { title: "null", src: p63 },
    { title: "null", src: p64 },
    { title: "null", src: p65 },
    { title: "null", src: p66 },
    { title: "null", src: p67 },
    { title: "null", src: p68 },
    { title: "null", src: p69 },
    { title: "null", src: p70 },
    { title: "null", src: p71 },
    { title: "null", src: p72 },
    { title: "null", src: p73 },
    { title: "null", src: p74 },
    { title: "null", src: p75 },
    { title: "null", src: p76 },
    { title: "null", src: p77 },
    { title: "null", src: p78 },
    { title: "null", src: p79 },
    { title: "null", src: p80 },
    { title: "null", src: p81 },
    { title: "null", src: p82 },
    { title: "null", src: p83 },
    { title: "null", src: p84 },
    { title: "null", src: p85 },
    { title: "null", src: p86 },
    { title: "null", src: p87 },
    { title: "null", src: p88 },
    { title: "null", src: p89 },
    { title: "null", src: p90 },
    // { title: "null", src: p91 },
    { title: "null", src: p92 },
    { title: "null", src: p93 },
    { title: "null", src: p94 },
    { title: "null", src: p95 },
    { title: "null", src: p96 },
    { title: "null", src: p97 },
    { title: "null", src: p98 },
    { title: "null", src: p99 },
    { title: "null", src: p100 },
    { title: "null", src: p101 },
    { title: "null", src: p102 },
    { title: "null", src: p103 },
    { title: "null", src: p104 },
    { title: "null", src: p105 },
    { title: "null", src: p106 },
    { title: "null", src: p107 },
    { title: "null", src: p108 },
    { title: "null", src: p109 },
    { title: "null", src: p110 },
  ];
  
